export const ROUTE_NAMES = {
    HOME: "home",
    DASHBOARD: "dashboard",
    WORK: "work",
    WORK_ENTITY: "work-entity",
    ACTIVITY: "activity",
    TEAM: "team",
    ALIGN: "align",
    REPORTS: "reports",
    DIRECTORY: "directory",
    SETTINGS: "settings",
    DIVISION: "division",
    INVITATION: "invitations",
    MOBILE: "mobile",
    MOBILE_ALIGN: "mobile-align",
    MOBILE_CREATE_PERSONAL_PROFILE: "mobile-create-personal-profile",
    MOBILE_CREATE_ORGANIZATION: "mobile-create-organization",
    MOBILE_WORKDAY: "mobile-workday",
    MOBILE_INVITE_TEAM: "mobile-invite-team",
    MOBILE_BUILD_PROJECTS: "mobile-build-projects",
    MOBILE_KNOW_KAAMFU: "mobile-know-kaamfu",
    MOBILE_GET_HELP: "mobile-get-help",
    MOBILE_WORK: "mobile-work",
    MOBILE_TEAM: "mobile-team",
    MOBILE_ACTIVITY: "mobile-activity",
    MOBILE_DIRECTORY: "mobile-directory",
    MOBILE_REPORTS: "mobile-reports",
    MOBILE_CONVERSATION: "mobile-conversation",
    MOBILE_KAI: "mobile-kai",
    MOBILE_DASHBOARD: "mobile-dashboard",
};
